import React, { useState, useEffect } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { LuSun } from "react-icons/lu";
import { PiHandbagSimpleFill } from "react-icons/pi";
import { auth } from "../../../firebase"; // Adjust the import path
import useAuthUser from "../../../auth/getUser"; // Adjust the import path
import EditProfileModal from "../../../common/Modal";
import ExperienceModal from "../../../common/ExperienceModal";
import Swal from "sweetalert2";
import axios from "axios";
import { supabase } from "../../../supabaseClient";
import formatDate from "../../../lib/formatDate";

const JobSeekerProfile = () => {
  const { user } = useAuthUser();
  const [profileData, setProfileData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalExOpen, setIsModalExOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [cvName, setCvName] = useState();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  console.log(user);
  const handleFileUpload = async () => {
    if (!file) {
      return;
    }

    const bucketName = "Airtalx"; // Ensure this matches your actual bucket name
    const { data, error } = await supabase.storage
      .from(bucketName)
      .upload(file.name, file); // Upload directly to the bucket root

    if (error) {
      console.error("Error uploading file:", error);
    } else {
      console.log("File uploaded successfully:", data);

      // Construct the public URL manually
      const projectRef = "cponmlknhqaykmafxpkl"; // Your Supabase project reference
      const publicURL = `https://${projectRef}.supabase.co/storage/v1/object/public/${bucketName}/${data.path}`;

      // Log the manually constructed public URL
      console.log("Manually constructed public URL:", publicURL);
      if (publicURL) {
        setCvName(file.name);
        const data = {
          cv: {
            name: file.name,
            url: publicURL,
          },
        };
        console.log(publicURL, user?._id);
        const updateUserCv = await axios.patch(
          `${process.env.REACT_APP_BASE_API}/userdata/update/${user?._id}`,
          data
        );

        console.log(updateUserCv.data);
      }

      setIsUploadModalOpen(false);
      Swal.fire({
        title: "Success",
        text: "Your resume has been uploaded successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
    }
  };

  const handleToggle = async (e) => {
    console.log("this is toggle", e.target.checked);
    if (e.target.checked) {
      if (e.target.checked === true) {
        const response = await axios.patch(
          `${process.env.REACT_APP_BASE_API}/userdata/update/${user?._id}`,
          { isVisable: true }
        );
        if (response.data) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: "Profile is visable now",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } 
      
      
    } else {
      if (e.target.checked === false) {
        const response = await axios.patch(
          `${process.env.REACT_APP_BASE_API}/userdata/update/${user?._id}`,
          { isVisable: false }
        );
        if (response.data) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: "Profile is hidden now!",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
      // Handle toggle logic
    }
  };

  const handleEditProfileClick = () => {
    setIsModalOpen(true);
  };

  const handleAddExperienceClick = () => {
    setIsModalExOpen(true);
  };

  const handleCloseExModal = () => {
    setIsModalExOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
  };

  const handleProfileUpdate = (updatedData) => {
    setProfileData(updatedData);
  };

  useEffect(() => {
    setProfileData(user);
  }, [user]);

  const handleDeleteAccount = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Make API call to delete user from your database
          await axios.delete(
            `${process.env.REACT_APP_BASE_API}/userdata/${user?._id}`
          );

          // Delete user from Firebase Authentication
          const currentUser = auth.currentUser;
          if (currentUser) {
            await currentUser.delete();
          }

          Swal.fire({
            title: "Success",
            text: "Your account has been deleted successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            // Optionally, you can redirect the user to a different page
            window.location.href = "/login";
          });
        } catch (error) {
          console.error("Error deleting account:", error);
          Swal.fire({
            title: "Error",
            text: "Failed to delete your account. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const handleDownload = async (downloadLink, fileName) => {
    if (typeof window !== undefined) {
      const imageUrl = downloadLink;
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
  };

  return (
    <div className="m-2 max-w-7xl mx-auto">
      {/* Part 1 */}
      <div className="md:flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <div>
            <img
              src={profileData?.image}
              className="w-10 h-10 rounded-full"
              alt=""
            />
          </div>
          <div>
            <h2 className="text-[24px] font-medium">{profileData?.name}</h2>
            <div className="flex gap-1 text-[14px]">
              <p>Age: {profileData?.age}</p>
              <p>, Member Since {formatDate(profileData?.createdAt)}</p>
            </div>
          </div>
        </div>

        <div className="max-md:mt-5">
          <button className="text-[16px] font-semibold flex items-center gap-2">
            Make visible to public{" "}
            <label className="switch">
              <input onChange={handleToggle} type="checkbox" />
              <div className="slider">
                <div className="circle">
                  <LuSun className="text-warning" />
                </div>
              </div>
            </label>
          </button>
        </div>
      </div>

      {/* Part 2 */}
      <div className="md:grid grid-cols-3">
        <div className="mt-[24px] grid grid-cols-2 col-span-2">
          <div>
            <div>
              <h2 className="text-[14px]">Email Address</h2>
              <h2 className="text-[16px] text-slate-400">
                {profileData?.email}
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Phone Number</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.phone_number || "null"}
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Portfolio</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.portfolio || "null"}
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Preferred Salary</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.salary || "null"}/hr
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Skill</h2>
              <h2 className="text-[16px] font-medium">{profileData?.skill}</h2>
            </div>
          </div>
          <div>
            <div>
              <h2 className="text-[14px]">Location</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.location}
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Current Job</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.current_job}
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Current Company</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.current_company || "null"}
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Preferred Employment</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.employment || "null"}
              </h2>
            </div>
            <div className="mt-3">
              <h2 className="text-[14px]">Skill Level</h2>
              <h2 className="text-[16px] font-medium">
                {profileData?.skill_level}
              </h2>
            </div>
          </div>
        </div>
        <div className="mt-[24px] flex flex-col">
          <button
            className="bg-[#2792A8] px-6 py-3 text-white rounded-lg hover:bg-[#1f7280]"
            onClick={handleEditProfileClick}
          >
            Edit Profile
          </button>

          <button
            className="btn btn-outline mt-5 border border-gray-400 text-gray-600 hover:bg-gray-200 p-5"
            onClick={() => setIsUploadModalOpen(true)}
          >
            Upload Resume
          </button>
          {user?.cv?.url && (
            <div className="mt-5">
              <h3 className="text-[12px] font-medium">
                {cvName || user?.cv?.name || ""}
              </h3>
              <button
                onClick={() => handleDownload(user?.cv?.url, user?.cv?.name)}
                className="text-blue-500 hover:underline"
              >
                Download Resume
              </button>
            </div>
          )}

          <button
            onClick={handleDeleteAccount}
            className="text-red-500 mt-24 flex gap-2 hover:text-red-600"
          >
            Delete Account <AiOutlineDelete className="text-xl" />
          </button>
        </div>
      </div>

      {/* Part 3 */}
      <div className="border border-base-200 rounded-xl p-4 mt-[24px]">
        <h2>Summary</h2>
        <p>{user?.summary}</p>
      </div>

      {/* Part 4 */}
      <div className="border border-base-200 rounded-xl p-4 mt-[24px]">
        <div className="flex gap-3 items-center justify-between">
          <div className="flex gap-2 items-center">
            <PiHandbagSimpleFill className="text-4xl text-[#2792A8]" />
            <div>
              <h2 className="text-[24px]">Experience</h2>
              <h2 className="text-[14px]">
                Add experience to increase the chance of hiring
              </h2>
            </div>
          </div>
          <div>
            <button
              onClick={handleAddExperienceClick}
              className="text-[#2792A8] hover:text-[#1f7280]"
            >
              Add Experience
            </button>
          </div>
        </div>
        {/* Experience List */}
        <div className="mt-6">
          {profileData?.experience?.map((m) => (
            <div
              key={m._id}
              className=" m-3 p-3 border-b-2 border-base-200  grid-cols-2 items-center gap-3"
            >
              <div className="grid grid-cols-2 items-center">
                <div className="flex gap-3 items-center">
                  <img
                    src="/assets/skill.png"
                    className="w-[72px] h-[72px]"
                    alt=""
                  />
                  <div>
                    <h2 className="text-[20px]">{m.title}</h2>
                    <h2 className="text-[14px]">{m.company}</h2>
                    <h2 className="text-[14px]">{m.start_date}</h2>
                  </div>
                </div>
                <div className="flex justify-end gap-2 items-center">
                  <label className="switch">
                    <input onChange={handleToggle} type="checkbox" />
                    <div className="slider">
                      <div className="circle">
                        <LuSun className="text-warning" />
                      </div>
                    </div>
                  </label>
                  <p>Show</p>
                </div>
              </div>
              <div>{m.description}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Edit Profile Modal */}
      <EditProfileModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        user={profileData}
        onProfileUpdate={handleProfileUpdate}
      />
      <ExperienceModal
        isOpen={isModalExOpen}
        onClose={handleCloseExModal}
        user={profileData}
      />

      {/* Upload Resume Modal */}
      {isUploadModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-lg">
            <h2 className="text-lg font-medium mb-4">Upload Resume</h2>
            <input type="file" onChange={handleFileChange} />
            <button
              className="bg-green-500 text-white px-4 py-2 mt-4 rounded"
              onClick={handleFileUpload}
            >
              Upload
            </button>
            <button
              className="bg-red-500 text-white px-4 py-2 mt-4 rounded"
              onClick={handleCloseUploadModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobSeekerProfile;
